module.exports = __webpack_public_path__ + "img/flea.e98a9a1d.jpg";